import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { PersonaSearchService } from 'src/app/services/persona-search.service';

@Component({
  selector: 'apc-search-autocomplete',
  templateUrl: './search-autocomplete.component.html',
  styleUrls: ['./search-autocomplete.component.scss'],
})

export class SearchAutocompleteComponent {
  quickSearch = new Subject<any>();
  queryString: string = '';
  searchValue: string = '';
  result: any = '';
  isLoading: boolean = false;
  isOpen: boolean = false;
  @Input() showEnvWarning: boolean;

  constructor(private personaSearchService: PersonaSearchService, private router: Router) {
    this.quickSearch.pipe(debounceTime(1000), distinctUntilChanged()).subscribe((input) => {
      this.search(input.value);
    });
  }

  redirectToUser(identifier: string) {
    if (this.router.url.includes('/persona/')) {
      let url = this.router.url.split('/');
      url[2] = identifier;
      let finalUrl = url.join('/');
      this.router.routeReuseStrategy.shouldReuseRoute = function () {
        return false;
      };
      this.router.onSameUrlNavigation = 'reload';
      this.router.navigate([finalUrl]);
    } else {
      this.router.navigate(['persona/' + identifier]);
    }
    this.queryString = '';
    this.searchValue = '';
    this.result = [];
    this.isOpen = false;
  }

  async search(value: string) {
    this.searchValue = value;
    this.queryString = this.searchValue;
    this.isLoading = true;
    if (this.queryString.length > 0) {
      this.personaSearchService.getPersonas(this.queryString).then(res => {
        this.result = res;
        this.isLoading = false;
      }, reason => {
        this.isLoading = false;
      });
    } else {
      this.result = [];
      this.isLoading = false;
    }
  }

  openSearch() {
    this.isOpen = true;
    setTimeout(() => document.getElementById('quick-search').focus(), 200);
  }

  closeSearch() {
    this.isOpen = false;
    setTimeout(() => {
      this.result = [];
      this.searchValue = '';
      this.queryString = '';
    }, 800 )
  }
}
